import { isString } from 'utils/helpers';
import { HANDLEBAR_REGEX } from '../constants';

export const isHandlebarSyntax = (value?: string) => {
  return isString(value) && HANDLEBAR_REGEX.test(value);
};
